import { useEffect, useState } from "react";
import { API_URL } from "../../constants/app";
import axios from "axios";
import { Box } from "@chakra-ui/react";
export default function PrivacyPolicy() {

    const [data, setData] = useState("");

    let privacy = `${API_URL}/upload/Privacy_Policy_En.html`;

    useEffect(() => {
        axios.get(privacy, {}).then((res) => {
            setData(res.data)
        });
    }, [privacy])
    
	return (
        <Box px="7vw" py="2vh">
            <div dangerouslySetInnerHTML={{ __html: data }} />
        </Box>
	);
}
